import { getUpdaterFunction, type SetEditorStateFunction } from "@/contexts/editor-context-utils";
import { noop } from "lodash";
import type { StateUpdater } from "./utils";

/**
 * Global rewardful type definitions
 */
export interface RewardfulInstance {
  referral?: string;
  id?: string;
}

export interface RewardfulCallback {
  (event: "ready", callback: () => void): void;
  (event: "convert", data: { email: string }): void;
}

declare global {
  interface Window {
    rewardful: RewardfulCallback;
    Rewardful: RewardfulInstance;
    _rwq: string;
  }
}

export interface RewardfulEditorState {
  rewardfulReferral?: string;
  setRewardfulReferral: (value: StateUpdater<string | undefined>) => void;
}

export function getDummyRewardfulEditorState(): RewardfulEditorState {
  return {
    rewardfulReferral: undefined,
    setRewardfulReferral: noop,
  };
}

export function getDefaultRewardfulEditorState(set: SetEditorStateFunction): RewardfulEditorState {
  return {
    rewardfulReferral: undefined,
    setRewardfulReferral: getUpdaterFunction(set, "rewardfulReferral"),
  };
}
